import { custom, success } from "./utilities";
import { ToastifyService } from "../../services";
import { globalSystemConstants, leaderboardConstants } from "../../constants";
import { leaderboardService } from "../../services/leaderboard.service";

const {
  GET_RANKING,
  GET_COMPETITION_RANKING,
  LEADERBOARD_BOAT_CLASSES,
  LEADERBOARD_DATA_NULL,
} = leaderboardConstants;

export const getRanking = (params, sportId) => {
  return (dispatch) => {
    leaderboardService
      .getRankings(params, sportId)
      .then((response) => dispatch(success(response, GET_RANKING)))
      .catch((error) => {
        ToastifyService.showError(error);
        dispatch(custom(GET_RANKING, globalSystemConstants.SPINNER_DEACTIVATE));
      });
  };
};

export const getCompetitionRanking = (params, competitionId) => {
  return (dispatch) => {
    dispatch(
      custom(GET_COMPETITION_RANKING, globalSystemConstants.SPINNER_ACTIVATE)
    );
    leaderboardService
      .getCompetitionRankings(params, competitionId)
      .then((response) => {
        dispatch(success(response, GET_COMPETITION_RANKING));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            GET_COMPETITION_RANKING,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getLeaderboardBoatClasses = (year) => {
  return (dispatch) => {
    dispatch(
      custom(LEADERBOARD_BOAT_CLASSES, globalSystemConstants.SPINNER_ACTIVATE)
    );
    leaderboardService
      .getLeaderboardBoatClasses(year)
      .then((response) => dispatch(success(response, LEADERBOARD_BOAT_CLASSES)))
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            LEADERBOARD_BOAT_CLASSES,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const leaderboardDataNull = () => {
  return (dispatch) => {
    dispatch(success(null, LEADERBOARD_DATA_NULL));
  };
};

export const leaderboardActions = {
  getRanking,
  getCompetitionRanking,
  getLeaderboardBoatClasses,
  leaderboardDataNull,
};
